export enum Analytics {
	URL = 'https://go.pardot.com/l/67552/2015-01-16/d87?EmailAddress=',
}
